<template>
  <div class="asset-detail">

    <!-- 第一部分：导航栏 -->
    <header class="header">
      <div class="nav-container">
        <div class="logo-container">
          <img src="@/assets/img/logoNew.png" class="logo-img" alt="平台logo">
          <span class="logo-text">数据资产全过程AI服务平台</span>
        </div>
        <nav class="nav-links">
          <router-link to="/">官网首页</router-link>
          <router-link to="/infoPublic">信息公示</router-link>
          <router-link to="/about">关于平台</router-link>
        </nav>
        <div class="auth-buttons">
          <template v-if="!isLoggedIn">
            <router-link to="/login" class="login-btn">登录</router-link>
            <router-link to="/register" class="register-btn">注册</router-link>
          </template>
          <template v-else>

            <div class="user-avatar" @click="handleAvatarClick">
              <img :src="avatarUrl" alt="用户头像">
            </div>
          </template>
        </div>
      </div>
    </header>

    <!-- 第二部分：主标题区 -->
    <section class="hero">
      <div class="hero-content">
        <h1 class="hero-title">关于平台</h1>
        <p class="hero-subtitle1">&nbsp;&nbsp;&nbsp;&nbsp;数据资产全过程AI服务平台依托区块链、大数据、人工智能等前沿技术，</p>
        <p class="hero-subtitle1">平台核心功能覆盖并支撑数据资产录入、受理、审核、公示、转移、变更等全过程，</p>
        <p class="hero-subtitle1">面向全国提供数据资产登记服务。</p>
      </div>
    </section>

    <!-- 主要内容区 -->
    <section class="map-section">
      <h2 class="ecosystem-title ">平台介绍</h2>
      <div class="map-container">
        <img src="@/assets/img/about.png" alt="介绍">
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <p class="footer-title">数据资产全过程AI服务平台</p>
          <p>邮箱: yuanshuqiang@xinxiusz.com</p>
          <p>联系电话: 15831289727</p>
          <p>地址: 保定市竞秀区时代路数字大厦一楼</p>
        </div>
        <div class="footer-section">
          <div class="footer-links">

            <router-link to="/" class="footer-link">官网首页</router-link>
            <router-link to="/infoPublic" class="footer-link">信息公示</router-link>
            <router-link to="/about" class="footer-link">关于平台</router-link>
          </div>
        </div>

      </div>
      <div class="footer-bottom">
        <p>© 2025 数据资产全过程AI服务平台 版权所有 隐私政策 冀ICP备2025125156号</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'InfoPublic',
  data() {
    return {
      isLoggedIn: false,
      avatarUrl: ''
    }
  },
  created() {
    this.checkLoginStatus();
    this.setupLoginListener();

  },
  methods: {
    handleAvatarClick() {
      this.$router.push('/home');
    },
    checkLoginStatus() {
      const user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || 'null');
      this.isLoggedIn = !!user;
      if (user) {
        this.avatarUrl = user.avatar;
      }
      this.$forceUpdate();
    },
    setupLoginListener() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'user') {
          this.checkLoginStatus();
        }
      });
      // 添加轮询检查登录状态
      this.loginCheckInterval = setInterval(() => {
        this.checkLoginStatus();
      }, 1000);
    },
    beforeDestroy() {
      if (this.loginCheckInterval) {
        clearInterval(this.loginCheckInterval);
      }
    },
    created() {
      this.checkLoginStatus();
      this.setupLoginListener();
    }
  }

}
</script>

<style scoped>
/* 响应式布局 */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    padding: 10px;
  }

  .logo-container {
    margin: 0 auto 10px;
  }

  .nav-links {
    gap: 20px;
    margin: 10px auto;
  }

  .auth-buttons {
    margin: 10px auto;
  }

  .hero {
    padding: 60px 5%;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle1 {
    font-size: 16px;
  }

  .map-section {
    padding: 20px;
  }

  .footer-content {
    flex-direction: column;
  }

  .footer-section {
    margin-bottom: 20px;
    text-align: center;
  }
}

.asset-detail {
  font-family: 'Microsoft YaHei', sans-serif;
  color: #536a6b;
  background-color: #ffffff;


  line-height: 1.6;
}

body,
.map-section {
  padding: 80px 5%;
  text-align: center;
}

.ecosystem-title {
  font-size: 32px;
  margin-bottom: 50px;
  color: #333;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 主标题区样式 - 参考CompanyHome.vue */
.hero {
  background: url('../../assets/img/home_header_bg.png') no-repeat center center;
  background-size: cover;
  padding: 100px 5%;
  display: flex;
  align-items: center;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  text-align: left;
}

.hero-title {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.hero-subtitle1 {
  font-size: 18px;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
}

.hero-subtitle2 {
  font-size: 18px;
  margin-bottom: 40px;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
}

.cta-button {
  display: inline-block;
  background: #1E88E5;
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
}

.asset-name-section {
  text-align: center;
  margin-bottom: 30px;
}

.asset-name {
  font-size: 26px;
  color: #050708;
  font-weight: normal;
}

.detail-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.detail-card>>>.el-card__header {
  background-color: #e2e4e7;
  color: rgb(1, 1, 1);
  font-size: 16px;
  font-weight: 100;
  border-radius: 8px 8px 0 0;
}

.detail-card>>>.el-descriptions__title {
  font-size: 14px;
  color: #606266;
}

.detail-card>>>.el-descriptions-item__label {
  font-size: 16px;
  color: #000000;
  background-color: #fcfcfc;
  width: 150px;
}

.detail-card>>>.el-descriptions-item__content {
  font-size: 16px;
  color: #6b6b6b;
  background-color: #ffffff;
}

/* 导航栏 */
.header {
  background-color: #EEF1F9;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 5%;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  /* 确保靠左对齐 */
}

.logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 25px;
  font-weight: normal;
  color: #000000;
}

.nav-links {
  display: flex;
  gap: 80px;
  /* 将间距从30px增加到60px */
  margin: 0 auto;
  /* 保持居中 */
}

.nav-links a {
  color: #333;
  text-decoration: none;
  position: relative;
}

.nav-links a.router-link-exact-active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #1E88E5;
}


.auth-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}

.user-center-btn {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid #1E88E5;
  color: #1E88E5;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  margin-right: 10px;
  transition: all 0.3s;
}

.user-center-btn:hover {
  background: rgba(30, 136, 229, 0.1);
}

.user-avatar {
  display: flex;
  align-items: center;
}

.user-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.user-avatar img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.login-btn {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid #1E88E5;
  color: #1E88E5;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.register-btn {
  padding: 8px 20px;
  background: #1E88E5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.main-content {
  padding: 40px 5%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
}


.section {
  margin-bottom: 40px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #1E88E5;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.info-table {
  width: 100%;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-label {
  width: 150px;
  font-weight: bold;
  color: #666;
}

.info-value {
  flex: 1;
}

.info-grid {
  display: flex;
  gap: 40px;
}

.info-col {
  flex: 1;
}

.view-link {
  color: #1E88E5;
  text-decoration: none;
}

.description {
  margin-top: 20px;
}

.description h3 {
  margin-bottom: 10px;
  font-size: 18px;
}

.qr-code {
  text-align: center;
  margin-top: 20px;
}

.qr-code img {
  width: 200px;
  height: 200px;
}

.footer {
  background: #245a97;
  color: white;
  padding: 40px 5% 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  margin: 10px 0;
  flex-basis: 30%;
}

.footer-title {
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 20px;
  color: #ffffff;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer a,
.footer .footer-link {
  color: white;
  text-decoration: none;
  margin-top: 5px;
  margin-right: 10px;
  font-size: 15px;
  display: block;
  margin-bottom: 10px;
}

.footer a:hover,
.footer .footer-link:hover {
  text-decoration: underline;
}

.footer .router-link-active {
  font-weight: bold;
}

.footer-qr {
  display: flex;
  justify-content: space-around;
}

.qr-code {
  margin: 0 10px;
  text-align: center;
}

.qr-code img {
  width: 80px;
  height: 80px;
  margin-bottom: 5px;
}

.qr-code p {
  font-size: 12px;
  margin: 0;
}

.footer-bottom {
  text-align: center;
  width: 100%;
  margin-top: 30px;
  font-size: 12px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

@media (max-width: 768px) {
  .footer-section {
    flex-basis: 100%;
    margin-bottom: 20px;
  }

  .footer-links {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }

  .footer-link {
    margin: 0 10px;
  }
}
</style>
